module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioFinalExamenFIS3.a65e415a.pdf";